module.exports = __webpack_public_path__ + "img/ic-heart-bold-pink.d7991c39.svg";